import { render, staticRenderFns } from "./CreditScoringRekananMitra.vue?vue&type=template&id=6c6b5b42&scoped=true&"
import script from "./CreditScoringRekananMitra.vue?vue&type=script&lang=js&"
export * from "./CreditScoringRekananMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b5b42",
  null
  
)

export default component.exports